import { DefaultApi, Configuration, DefaultApiInterface, ErrorContext } from "./gen";
import { APIError, GeneralAPIError, NotOKResponseError } from "./errors";

export interface AuthenticatedAPIInterface extends DefaultApiInterface {
  isAuthenticated: boolean;
}

class AuthenticatedAPI extends DefaultApi implements AuthenticatedAPIInterface {
  isAuthenticated: boolean;
  constructor(configuration?: Configuration) {
    super(configuration);
    const accessToken = configuration?.accessToken;
    if (accessToken) {
      this.isAuthenticated = Boolean(
        typeof accessToken === "function" ? accessToken() : accessToken,
      );
    } else {
      this.isAuthenticated = false;
    }
  }
}

type CreateAuthenticatedAPIParams = {
  accessToken: string;
  basePath: string;
  logging?: boolean;
  onError: (err: APIError) => Promise<any>;
  headers?: Headers;
};

export function createAuthenticatedAPI({
  accessToken,
  basePath,
  logging,
  onError,
  headers,
}: CreateAuthenticatedAPIParams): AuthenticatedAPIInterface {
  const conf = new Configuration({
    accessToken,
    basePath,
    middleware: [
      {
        pre: (ctx) => {
          if (logging) {
            console.log(
              JSON.stringify({
                time: new Date(),
                type: "request",
                url: ctx.url,
              }),
            );
          }
          ctx.init.headers = mergeHeaders(ctx.init.headers, headers);
          return Promise.resolve(ctx);
        },
        post: async ({ url, response }) => {
          if (!response.ok) {
            onError(new NotOKResponseError(response));
          }
          if (logging) {
            let body = null;
            try {
              body = await response.json();
            } catch (_e) {}
            console.log(
              JSON.stringify({
                time: new Date(),
                type: "response",
                status: response.status,
                url,
                body,
              }),
            );
          }
        },
        onError(context: ErrorContext): Promise<Response | void> {
          return onError(new GeneralAPIError(context));
        },
      },
    ],
  });

  return new AuthenticatedAPI(conf);
}

function mergeHeaders(a?: HeadersInit, b?: HeadersInit): HeadersInit | undefined {
  const ret = new Headers(a);
  const c = new Headers(b);
  c.forEach((value: string, name: string) => {
    ret.set(name, value);
  });
  return ret;
}
